<template>
  <div class="find">
    <div class="find-left">
      <router-link :to="url">
        <van-button
          round
          size="small"
          :style="{ background: buttonColor1,color:'#ff4900', width:'97%',width:'97%',fontSize:'12px',fontWeight:'600'}"
        >查看课程</van-button>
      </router-link>
    </div>
    <div class="find-right">
       <div class="type1" v-if="show1">
        <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
          <van-button size="small" round  color="rgb(169, 22, 28)"  :style="{ background: buttonColor2,color:'#fff',border:'1px solid #ff4900', width:'97%',fontSize:'12px',fontWeight:'600'}">咨询学费</van-button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: this.goto,
      buttonColor1: this.color1,
      buttonColor2: this.color2,
      show1: true,
      show2: false
    };
  },
  methods: {},
  created() {this.show1 = true;
      this.show2 = false;

  },
  props: {
    goto: { type: String, default: "chat" },
    color1: {
      type: String,
      default: "#fff"
    },
    color2: {
      type: String,
      default: "#fe9900"
    }
  }
};
</script>

<style scoped>
.find {
  width: 100%;
  height: 40px;
}
.find-left {
  width: 50%;
  height: 50px;
  float: left;
  text-align: center;
}
.find-right {
  width: 50%;
  height: 50px;
  float: left;
  text-align: center;
}
</style>